// extracted by mini-css-extract-plugin
export var backdropBlur = "_l3-0";
export var contentCard = "_l3-5";
export var frame = "_l3-2";
export var image = "_l3-4";
export var imagePane = "_l3-3";
export var modal = "_l3-1";